import React, { createContext, useState } from 'react';

export const MemberSearchContext = createContext({
  tooManyRecords: false,
  setTooManyRecords: (state: boolean) => {}
});

export const MemberSearchContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [tooManyRecords, setTooManyRecords] = useState<boolean>(false);
  return (
    <MemberSearchContext.Provider value={{ tooManyRecords, setTooManyRecords }}>
      {children}
    </MemberSearchContext.Provider>
  );
};
